import { CarFuelCardListModel, CarFuelCardsListModel, DriverFuelCardListModel, FuelCardListModel } from "api";
import actionTypes from "constants/fuelCards";
import { load, store } from "helpers/filtersStorage";
import { handleActions } from "helpers/redux";
import { Action } from "redux-actions";

const params = load("fuel_cards_params", {});

const initialState = {
    key: "fuel_cards",
    allItems: [],
    driverItems: [],
    carItems: [],
    params: {
        start: 0,
        length: 30,
        filters: params.filters || [],
        queryFilter: params.queryFilter || {},
    },
    count: 0,
    allItemsCount: 0,
    driverItemsCount: 0,
    carItemsCount: 0,
    isLoadingList: true,
    isLoadingCount: true,
    shouldUpdate: true,
};

const {
    GET_ALL_FUEL_CARDS,
    GET_UNLINKED_FUEL_CARDS,
    GET_DRIVER_FUEL_CARDS,
    GET_CAR_FUEL_CARDS,
    SET_FUEL_CARDS_LOADING,
    MERGE_FUEL_CARDS_PARAMS,
} = actionTypes;

type State = {
    key: string;
    allItems: FuelCardListModel[];
    driverItems: DriverFuelCardListModel[];
    carItems: CarFuelCardsListModel[];
    allItemsCount: number;
    driverItemsCount: number;
    carItemsCount: number;
    params: {
        start?: number;
        length?: number;
        filters?: [];
        queryFilter?: {};
    };
    isLoadingList: boolean | {};
    isLoadingCount: boolean | {};
    shouldUpdate: boolean;
};
type GetItemsPayload<T> = { count: number; data: T[]; maxCount: number; start: number };
type MergeParamsPayload = {};

type CombinedPayloads =
    | GetItemsPayload<FuelCardListModel>
    | GetItemsPayload<CarFuelCardListModel>
    | GetItemsPayload<DriverFuelCardListModel>
    | MergeParamsPayload;

export default handleActions<State, CombinedPayloads>(
    {
        [GET_ALL_FUEL_CARDS]: (state, { payload }: Action<GetItemsPayload<FuelCardListModel>>) => ({
            ...state,
            allItems: payload.data,
            allItemsCount: payload.count,
            isLoadingList: false,
            isLoadingCount: false,
            shouldUpdate: false,
            maxCount: payload.maxCount,
            ...(payload.start !== undefined ? { params: { ...state.params, start: payload.start } } : {}),
        }),
        [GET_UNLINKED_FUEL_CARDS]: (state, { payload }: Action<GetItemsPayload<FuelCardListModel>>) => ({
            ...state,
            unlinkedItems: payload.data,
            unlinkedItemsCount: payload.count,
            isLoadingList: false,
            isLoadingCount: false,
            shouldUpdate: false,
            maxCount: payload.maxCount,
            ...(payload.start !== undefined ? { params: { ...state.params, start: payload.start } } : {}),
        }),
        [GET_DRIVER_FUEL_CARDS]: (state, { payload }: Action<GetItemsPayload<DriverFuelCardListModel>>) => ({
            ...state,
            driverItems: payload.data,
            driverItemsCount: payload.count,
            isLoadingList: false,
            isLoadingCount: false,
            shouldUpdate: false,
            maxCount: payload.maxCount,
            ...(payload.start !== undefined ? { params: { ...state.params, start: payload.start } } : {}),
        }),
        [GET_CAR_FUEL_CARDS]: (state, { payload }: Action<GetItemsPayload<CarFuelCardListModel>>) => ({
            ...state,
            carItems: payload.data,
            carItemsCount: payload.count,
            isLoadingList: false,
            isLoadingCount: false,
            shouldUpdate: false,
            maxCount: payload.maxCount,
            ...(payload.start !== undefined ? { params: { ...state.params, start: payload.start } } : {}),
        }),
        [SET_FUEL_CARDS_LOADING]: (state, { payload = true }) => ({
            ...state,
            isLoadingList: payload,
            isLoadingCount: payload,
            shouldUpdate: false,
        }),
        [MERGE_FUEL_CARDS_PARAMS]: (state, { payload }: Action<MergeParamsPayload>) => {
            const params = { ...state.params, ...payload };
            store("fuel_cards_params", params);
            return {
                ...state,
                maxCount: undefined,
                params,
                shouldUpdate: true,
            };
        },
    },
    initialState,
);
